import { PackageStatus } from '@mandae/catalogo';
import { ListingSearchFilter, ListingSearchType } from './interfaces/listing-search-filter';

export const PackageTrackingCodeFilter: ListingSearchFilter = {
  displayType: ListingSearchType.Text,
  value: 'rastreamento',
  viewValue: 'Rastreamento',
  placeholder: 'Código de rastreamento da remessa',
};

export const RecipientNameFilter: ListingSearchFilter = {
  displayType: ListingSearchType.Text,
  value: 'nomeDestinatario',
  viewValue: 'Nome do destinatário',
  placeholder: 'Nome do destinatário',
};

export const PackageStatusFilter: ListingSearchFilter = {
  displayType: ListingSearchType.Enum,
  // Valor utilizado como situacao da encomenda, no historico de encomendas do pedido-services
  value: 'situacaoPedido',
  viewValue: 'Situação da encomenda',
  placeholder: '',
  options: Object.keys(PackageStatus)
    .filter(a => PackageStatus[a] && PackageStatus[a].code)
    .sort((a, b) => PackageStatus[a].value - PackageStatus[b].value)
    .map(s => ({ value: PackageStatus[s].code, viewValue: PackageStatus[s].displayValue })),
};

export const PackageCourierTrackingCodeFilter: ListingSearchFilter = {
  displayType: ListingSearchType.Text,
  value: 'codigoRastreioTransportadora',
  viewValue: 'Código transportadora',
  placeholder: 'Código da transportadora da remessa',
};
